import React from "react";
import { Alert } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";


import { Container } from "reactstrap";
import {
  GoogleReCaptcha
} from 'react-google-recaptcha-v3';
import { UserProfile } from "../store/Interfaces";
import LoadingModal from "./LoadingModal";


export default class RegistrationForm extends React.Component<{}> {
  public state: {
    email: string | undefined,
    captchaToken: string | undefined,
    isSuccess: string | undefined,
    isError: boolean;
    isLoading: boolean;
    refreshReCaptcha: boolean;
  }

  constructor(props: {}) {
    super(props);
    this.state = {
      email: undefined,
      captchaToken: undefined,
      isSuccess: undefined,
      isError: false,
      isLoading: false,
      refreshReCaptcha: false
    };
  }

  handleValidSubmit = (event: any, values: UserProfile) => {

    this.setState({
      isLoading: true,
    });

    if (this.state.captchaToken) {
      values.captchatoken = this.state.captchaToken;

      this.setState({
        isLoading: true,
        refreshReCaptcha: !this.state.refreshReCaptcha
      });
      fetch(
        process.env.REACT_APP_API_HOST + `/CABSBill/registration`, {
        method: "POST",
        // credentials: "include",
        body: JSON.stringify(values),
        headers: {
          pragma: "no-cache",
          "cache-control": "no-cache",
          "content-type": "application/json",
        },
      })
        .then((response) => response.text() as Promise<string>)
        .then((data) => {
          const parsed = parseInt(data, 0);
          if (isNaN(parsed)) {
            this.setState({ isLoading: false, isError: true,
              refreshReCaptcha: !this.state.refreshReCaptcha, });
          } else {

            if (parseInt(data, 0) > 0) {

              this.setState({
                isLoading: false,
                isError: false,
                isSuccess: "Your registration was submitted successfully.  Confirmation email was sent to: " + values.email,
                refreshReCaptcha: !this.state.refreshReCaptcha,
              });

            } else {

              this.setState({ isLoading: false, isError: true,
                refreshReCaptcha: !this.state.refreshReCaptcha, });
            }
          }
        })
        .catch((error) => {
          //  console.log(error);
          this.setState({ isLoading: false, isError: true,
            refreshReCaptcha: !this.state.refreshReCaptcha, });
        });


    } else {
      setTimeout(() => {
        this.handleValidSubmit(event, values);
      }
        , 500)

    }

  };

  handleInvalidSubmit = (event: any, errors: any, values: UserProfile) => {
    // this.setState({
    //   isLoading: false,
    //   isError: true,
    // });

  };

  // handleVerifyRecaptcha = async () => {
  //   const { executeRecaptcha } = (this.props as IWithGoogleReCaptchaProps)
  //     .googleReCaptchaProps;

  //   if (!executeRecaptcha) {
  //     console.log('Recaptcha has not been loaded');

  //     return;
  //   }

  //   const token = await executeRecaptcha('homepage');
  // };

  render() {

    return (
      <>
        {this.state.isSuccess && <Alert color="success">{this.state.isSuccess}</Alert>}
        {this.state.isError && <Alert color="danger">There was a problem with your submission.  Please try again.</Alert>}

        {this.state.isSuccess === undefined && <AvForm
          onValidSubmit={this.handleValidSubmit}
          onInvalidSubmit={this.handleInvalidSubmit}

        >
          <AvField
            name="companyname"
            label="Company Name"
            type="text"
            validate={{
              required: { value: true, errorMessage: 'Please enter a Company Name' },
            }}
          />

          <AvField
            name="banlistraw"
            label="Billing Account Number (BAN) – Use comma to separate BANs if more than one."
            type="text"
            validate={{
              required: true

            }}
          />
          <AvField
            name="Name"
            label="Contact Name"
            type="text"
            validate={{
              required: { value: true, errorMessage: 'Please enter a Name' },
            }}
          />
          <AvField
            name="phone"
            label="Contact Phone"
            type="text"
            validate={{
              required: { value: true, errorMessage: 'Please enter a Contact Phone Number' },
            }}
          />
          <AvField
            name="email"
            label="Contact Email"
            type="text"
            validate={{
              required: { value: true, errorMessage: 'Please enter a valid email' },
              email: true,
            }}
          />
          <Container>
            <p>
              You will be contacted if there are any questions regarding your
              Registration information. An email will be sent to you providing your assigned User ID and link to set up your Password.
            </p>
          </Container>


          <div className="d-flex flex-row flex-wrap justify-content-between">
            <div className="d-flex flex-col">
              <button className="btn btn-inverse btn-primary btn-sm" id="submit"><strong>SUBMIT</strong></button>


            </div>
            <div className="d-flex flex-col">
              <GoogleReCaptcha
                refreshReCaptcha={this.state.refreshReCaptcha}
                onVerify={(token) => {
                  this.setState({ captchaToken: token })
                }}
              />

            </div>
          </div>
        </AvForm>
        }

        <LoadingModal isLoading={this.state.isLoading}></LoadingModal>
      </>
    );
  }

}


